import { ANSWER_MESSAGE, OrdenExpressGetUserCredentials, OrdenExpressValidateSecurityForAnswer } from 'orden_express/frameWork/frameWork';
import { ofType } from 'redux-observable';
import { URL_SERVER } from 'routes';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs/index';
import { catchError, map, mergeMap } from 'rxjs/operators';


const REQUEST_SAVE_ROUTE = 'REQUEST_SAVE_ROUTE';
export const requestSaveRoute = (requestSaveRoute) => (
  {
    type: REQUEST_SAVE_ROUTE,
    requestSaveRoute
  }
);
export const RESPONSE_SAVE_ROUTE = 'RESPONSE_SAVE_ROUTE';
const responseSaveRoute = responseSaveRoute => (
  {
    type: RESPONSE_SAVE_ROUTE,
    responseSaveRoute
  }
);
export const fromServerSaveRoute = (action$, state$) => action$.pipe(
  ofType(REQUEST_SAVE_ROUTE),
  mergeMap(action =>
    ajax.post(URL_SERVER + '/route/save', action.requestSaveRoute, OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseSaveRoute(OrdenExpressValidateSecurityForAnswer(response.response))),
      catchError(error => of(responseSaveRoute(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);

const REQUEST_GET_ROUTES = 'REQUEST_GET_ROUTES';
export const requestGetRoutes = () => (
  {
    type: REQUEST_GET_ROUTES
  }
);

export const RESPONSE_GET_ROUTES = 'RESPONSE_GET_ROUTES';
const responseGetRoutes = responseGetRoutes => (
  {
    type: RESPONSE_GET_ROUTES,
    responseGetRoutes
  }
);

export const fromServerGetRoutes = (action$, state$) => action$.pipe(
  ofType(REQUEST_GET_ROUTES),
  mergeMap(action =>
    ajax.getJSON(URL_SERVER + '/route/getAll', OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseGetRoutes(OrdenExpressValidateSecurityForAnswer(response))),
      catchError(error => of(responseGetRoutes(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);

export const REQUEST_RESET_STATE_ROUTES = 'REQUEST_RESET_STATE_ROUTES';
export const requestResetStateRoutes = () => (
  {
    type: REQUEST_RESET_STATE_ROUTES
  }
);

export default this;